var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ../~/_lodash@4.17.15@lodash/_Uint8Array.js
// module id = 1196
// module chunks = 0